import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { buscarProcessoComFiltrosSimples } from '../../services/core/processos/processosService';
import { setResultadoAction } from '../../store/Processos/PesquisaUnificada/pesquisaProcessosUnificada.store';

/**
 * Busca um processo pelo número — mesmo service (`buscarProcessoComFiltrosSimples`,
 * `pageable={page:0,size:1}`, `ordenacao=['nroProcesso,ASC']`) e mesma action
 * (`setResultadoAction`) já duplicados em `HomePage.jsx`/`PesquisaProcessosPage.jsx`
 * antes desta extração — `ControleProcessosPage.jsx` (busca por `nroProcesso`
 * na query string, ao abrir "Inspecionar" da grid de Antecedentes numa nova
 * aba) é a 3ª página com esse mesmo fluxo, cruzando o limite documentado em
 * `src/prototipo/CLAUDE.md` ("2x aceitável, 3ª extrai").
 *
 * Callback-based (`onEncontrado`/`onNaoEncontrado`) em vez de expor um
 * `erro`/`resultado` próprio — cada página já reage ao sucesso/falha de um
 * jeito diferente (navegar direto, marcar um ref de "fui eu quem disparou"
 * antes do dispatch, ou só deixar a store populada) e mostra a mensagem de
 * "não encontrado" com seu próprio mecanismo de toast/Snackbar (severidade,
 * texto ao redor, etc. já variam entre as 3 páginas) — o hook não deve
 * decidir isso por elas.
 */
export default function useBuscarProcessoPorNumero() {
  const dispatch = useDispatch();
  const [buscando, setBuscando] = useState(false);

  const buscar = async (numeroProcesso, { onEncontrado, onNaoEncontrado } = {}) => {
    const numero = String(numeroProcesso || '').trim();
    if (!numero) {
      return;
    }

    setBuscando(true);
    try {
      const response = await buscarProcessoComFiltrosSimples(
        { numeroProcesso: numero },
        0,
        1,
        ['nroProcesso,ASC'],
      );
      const encontrado = (response?.data?.content || []).length > 0;
      if (encontrado) {
        dispatch(setResultadoAction(response.data.content));
        if (onEncontrado) {
          onEncontrado();
        }
      } else if (onNaoEncontrado) {
        onNaoEncontrado();
      }
    } catch {
      if (onNaoEncontrado) {
        onNaoEncontrado();
      }
    } finally {
      setBuscando(false);
    }
  };

  return { buscar, buscando };
}
